import { QueryResources } from 'datx-jsonapi-react';

import { ConferenceHubCounters } from '@/resources/ConferenceHubCounters';

export const queryConferenceHubCounters = (
  conference_id: Array<string>,
  hub_id: string
): QueryResources<ConferenceHubCounters> => {
  if (conference_id.length === 0) return null;
  if (!hub_id) return null;
  return [
    ConferenceHubCounters,
    {
      filter: {
        conference_id,
        hub_id,
      },
      params: [
        { key: 'page[number]', value: '1' },
        {
          key: 'page[size]',
          value: '100',
        },
      ],
    },
  ];
};
